<template>
  <ion-page>
    <ion-header class="ion-no-border">
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button @click="modalController.dismiss()">
            <ion-icon
              :src="require('@lib/assets/icons/icon_zurueck.svg')"
              slot="start"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content ref="content" :fullscreen="true">
      <ion-grid fixed class="ion-padding">
        <ion-row>
          <ion-col>
            <div
              class="c-header u-bg-yellow"
              :style="{
                'background-image':
                  'url(' +
                  require('@/assets/img/content/icon_roodie_call.svg') +
                  ')',
              }"
            ></div>
            <p>
              <b>So einfach geht’s:</b>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_telefon.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>1.</b> Sie erhalten Ihre Teilnahmeerklärung für Ihr
                  Coaching direkt in der Roodie App. Signieren Sie diese digital
                  oder händisch.</ion-col
                >
              </ion-row>
            </p>
            <!-- <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_artzwechsel.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>2.</b> Die Teilnahmeerklärung wird Ihnen von der ARAG
                  in Kürze per Post zugestellt.
                </ion-col>
              </ion-row>
            </p> -->
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="
                      require('@lib/assets/icons/icon_verlaufskontrolle.svg')
                    "
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>2.</b> Senden Sie bitte die unterzeichnete
                  Teilnahmeerklärung über die Roodie ARAG App oder per Post
                  direkt an MedicalContact.
                </ion-col>
              </ion-row>
            </p>
            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_erstdiagnose.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>3.</b> Ihr persönlicher Coach von MedicalContact ruft
                  Sie an. Er führt mit Ihnen ein Aufnahmegespräch in das
                  Programm und erstellt mit Ihnen gemeinsam die Inhalte Ihres
                  Coachings.
                </ion-col>
              </ion-row>
            </p>

            <p>
              <ion-row>
                <ion-col size="auto">
                  <ion-icon
                    size="large"
                    :src="require('@lib/assets/icons/icon_coach.svg')"
                  />
                </ion-col>
                <ion-col>
                  &nbsp;<b>4.</b> Das Coaching kann beginnen. Ihr Coach führt
                  regelmäßig mit Ihnen Gespräche.
                </ion-col>
              </ion-row>
            </p>

            <!-- <ion-row>
              <ion-col size="auto">
                <ion-icon :src="require('@lib/assets/icons/info.svg')" />
              </ion-col>
              <ion-col>
                <ion-text color="primary" class="u-xsmall"
                  >Auch medizinische Hilfsmittel wie Schrittzähler, Blutzucker-
                  oder Blutdruckmessgerät werden Ihnen bei Bedarf kostenlos zur
                  Verfügung gestellt.
                </ion-text>
              </ion-col>
            </ion-row> -->
          </ion-col>
        </ion-row>
      </ion-grid>
    </ion-content>
  </ion-page>
</template>

<script>
import { chevronBack } from "ionicons/icons";
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonContent,
  IonButton,
  IonGrid,
  IonRow,
  IonCol,
  IonIcon,
  IonButtons,
  IonText,
  modalController,
} from "@ionic/vue";

export default {
  components: {
    IonPage,
    IonHeader,
    IonToolbar,
    IonContent,
    IonButton,
    IonGrid,
    IonRow,
    IonCol,
    IonIcon,
    IonButtons,
    IonText,
  },
  props: {
    from: {
      required: false,
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  setup() {
    return {
      chevronBack,
      modalController,
    };
  },
};
</script>

<style lang="scss" scoped></style>
